<template>
  <div>
    <input
      id="formFile"
      ref="fileInput"
      class="d-none"
      type="file"
      accept="image/*"
      @change="internalOnFileChange"
    />

    <div class="mc-file-input-container" :class="{ 'is-invalid': isFileError }">
      <div class="mc-file-input-button" @click="triggerFileInput">Pilih Foto</div>

      <div class="mc-file-input-text" :class="{ 'has-file': fileName || localFileName }">
        {{ fileName || localFileName || 'Tidak ada foto terpilih' }}
      </div>

      <button v-if="fileName" type="button" class="mc-file-input-delete" @click.stop="handleRemove">
        <i class="icon-outline_trash-2"></i>
      </button>
    </div>
    <small v-if="isFileError" class="text-danger">{{ validationText }}</small>
  </div>
</template>

<script>
export default {
  props: {
    context: {},
    isFileError: {},
    onFileChange: {},
    validationText: {},
    fileName: {
      type: String,
      default: '',
    },
    onRemove: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      localFileName: '',
    }
  },
  methods: {
    internalOnFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.localFileName = file.name
      }
      if (this.onFileChange) {
        this.onFileChange(e)
      }
    },
    triggerFileInput() {
      if (this.context.attributes.onCustomClick) {
        this.context.attributes.onCustomClick()
        return
      }
      this.$refs.fileInput.click()
    },
    handleRemove() {
      this.onRemove()
      this.localFileName = ''
      this.$refs.fileInput.value = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-file-input-container {
  display: flex;
  width: 100%;
  border: 1px solid #99a1b1;
  border-radius: 4px;
  height: 38px;
  cursor: pointer;
  overflow: hidden;
  background-color: #fff;

  &.is-invalid {
    border-color: #dc3545;
  }

  &:hover {
    border-color: #0056b3;
  }
}

.mc-file-input-button {
  padding: 0 16px;
  display: flex;
  align-items: center;
  border-right: 1px solid #99a1b1;
  color: #0056b3;
  font-weight: 500;
  white-space: nowrap;
  font-size: 14px;
  background-color: #fff;
  cursor: pointer;
}

.mc-file-input-text {
  padding: 0 12px;
  display: flex;
  align-items: center;
  color: #99a1b1;
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;

  &.has-file {
    color: #344264;
  }
}

.mc-file-input-delete {
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: none;
  border-left: 1px solid #99a1b1;
  cursor: pointer;
  color: #dc3545;

  &:hover {
    background-color: #f8f9fa;
  }

  i::before {
    font-size: 16px;
  }
}
</style>
